/* Bazaar theme — global behaviours */
(function () {
  'use strict';

  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- Toast ---------------- */

  window.showToast = function (message) {
    var root = document.getElementById('ToastRoot');
    if (!root) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.textContent = message;
    root.appendChild(el);
    setTimeout(function () { el.remove(); }, 3200);
  };

  /* ---------------- Announcement rotator ---------------- */

  qsa('[data-announcement]').forEach(function (bar) {
    var slides = qsa('.announcement__slide', bar);
    if (slides.length < 2) return;
    var i = 0;
    var speed = parseInt(bar.dataset.speed, 10) || 5000;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, speed);
  });

  /* ---------------- Sidebar / mobile nav accordions ---------------- */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sidebar-toggle]');
    if (!toggle) return;
    var item = toggle.closest('[data-has-children]');
    if (!item) return;
    // First tap opens the submenu; the link itself still works on a second tap.
    if (!item.classList.contains('is-open')) {
      e.preventDefault();
      item.classList.add('is-open');
    }
  });

  /* ---------------- Mobile nav drawer ---------------- */

  var mobileNav = qs('[data-mobile-nav]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-nav-open]')) { e.preventDefault(); openMobileNav(); }
    if (e.target.closest('[data-mobile-nav-close]')) { e.preventDefault(); closeMobileNav(); }
  });

  /* ---------------- Locale panel & tooltip ---------------- */

  qsa('[data-locale-toggle]').forEach(function (btn) {
    var wrap = btn.parentElement;
    var panel = qs('[data-locale-panel]', wrap);
    var tooltip = qs('[data-locale-tooltip]', wrap);

    if (tooltip) {
      if (sessionStorage.getItem('localeTooltipSeen')) {
        tooltip.hidden = true;
      } else {
        setTimeout(function () {
          tooltip.hidden = true;
          sessionStorage.setItem('localeTooltipSeen', '1');
        }, 6000);
      }
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (tooltip) { tooltip.hidden = true; sessionStorage.setItem('localeTooltipSeen', '1'); }
      if (panel) panel.hidden = !panel.hidden;
    });
  });

  /* ---------------- Facet panels (collection page) ---------------- */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-facet-toggle]');
    if (toggle) {
      e.stopPropagation();
      var facet = toggle.closest('[data-facet]');
      var panel = qs('[data-facet-panel]', facet);
      var wasHidden = panel.hidden;
      qsa('[data-facet-panel]').forEach(function (p) { p.hidden = true; });
      panel.hidden = !wasHidden;
      return;
    }
    if (!e.target.closest('[data-facet-panel]') && !e.target.closest('[data-locale-panel]')) {
      qsa('[data-facet-panel]').forEach(function (p) { p.hidden = true; });
      qsa('[data-locale-panel]').forEach(function (p) { p.hidden = true; });
    }
  });

  var facetForm = qs('[data-facet-form]');
  if (facetForm) {
    var submitFacets = function () {
      var params = new URLSearchParams(new FormData(facetForm));
      // Drop empty values so the URL stays readable.
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      var results = qs('[data-collection-results]');
      if (results) results.classList.add('is-loading');
      window.location.search = clean.toString();
    };

    qsa('[data-facet-apply]', facetForm).forEach(function (b) { b.addEventListener('click', submitFacets); });
    var sortSelect = qs('[data-facet-sort]', facetForm);
    if (sortSelect) sortSelect.addEventListener('change', submitFacets);
    qsa('[data-facet-panel] input[type="checkbox"]', facetForm).forEach(function (input) {
      input.addEventListener('change', submitFacets);
    });
  }

  /* ---------------- Tabs ---------------- */

  qsa('[data-tabs]').forEach(function (root) {
    qsa('[data-tab-trigger]', root).forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var id = trigger.dataset.tabTrigger;
        qsa('[data-tab-trigger]', root).forEach(function (t) {
          var on = t === trigger;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        qsa('[data-tab-panel]', root).forEach(function (p) {
          p.hidden = p.dataset.tabPanel !== id;
        });
      });
    });
  });

  /* ---------------- Trending grid: client-side filter + sort ---------------- */

  qsa('[data-trending]').forEach(function (root) {
    var grid = qs('[data-trending-grid]', root);
    if (!grid) return;
    var items = qsa('[data-trending-item]', grid);
    var activeTag = '*';
    var inStockOnly = false;

    function apply() {
      items.forEach(function (item) {
        var tags = (item.dataset.tags || '').split(',').map(function (t) { return t.trim(); });
        var tagOk = activeTag === '*' || tags.indexOf(activeTag) !== -1;
        var stockOk = !inStockOnly || item.dataset.available === 'true';
        item.hidden = !(tagOk && stockOk);
      });
    }

    qsa('[data-trending-filter]', root).forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeTag = chip.dataset.trendingFilter;
        qsa('[data-trending-filter]', root).forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        apply();
      });
    });

    var stockToggle = qs('[data-trending-instock]', root);
    if (stockToggle) {
      stockToggle.addEventListener('change', function () { inStockOnly = stockToggle.checked; apply(); });
    }

    var sortSelect = qs('[data-trending-sort]', root);
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var mode = sortSelect.value;
        var sorted = items.slice();
        if (mode === 'price-asc') sorted.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
        if (mode === 'price-desc') sorted.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
        if (mode === 'discount') sorted.sort(function (a, b) { return b.dataset.discount - a.dataset.discount; });
        sorted.forEach(function (el) { grid.appendChild(el); });
      });
    }
  });

  /* ---------------- Wishlist (localStorage) ---------------- */

  var WISHLIST_KEY = 'bazaar:wishlist';

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (err) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (err) { /* storage full or blocked */ }
  }

  function paintWishlist() {
    var list = readWishlist();
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.dataset.handle) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.dataset.handle;
    var list = readWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
    writeWishlist(list);
    paintWishlist();
  });

  paintWishlist();

  /* ---------------- Share button ---------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-button]');
    if (!btn) return;
    var url = btn.dataset.url;
    if (navigator.share) {
      navigator.share({ title: btn.dataset.title, url: url }).catch(function () { /* user dismissed */ });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { window.showToast('Link copied'); });
    }
  });

  /* ---------------- Product gallery ---------------- */

  qsa('[data-gallery]').forEach(function (gallery) {
    var thumbs = qsa('[data-thumb]', gallery);
    var stages = qsa('[data-stage-item]', gallery);

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = thumb.dataset.thumb;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        stages.forEach(function (s) { s.classList.toggle('is-active', s.dataset.stageItem === i); });
      });
    });
  });

  /* ---------------- Product variants ---------------- */

  qsa('[data-product-root]').forEach(function (root) {
    var picker = qs('[data-variant-picker]', root);
    var form = qs('form[action*="/cart/add"]', root);
    var variantInput = qs('[data-variant-input]', root);
    var addBtn = qs('[data-add-to-cart]', root);
    var addBtnText = qs('[data-add-to-cart-text]', root);
    var priceEl = qs('[data-price]', root);
    var compareEl = qs('[data-compare-price]', root);
    var discountEl = qs('[data-discount]', root);

    /* Quantity stepper */
    var qtyInput = qs('[data-pdp-qty-input]', root);
    var hiddenQty = qs('[data-quantity-input]', root);
    qsa('[data-pdp-qty]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.pdpQty, 10));
        qtyInput.value = next;
        if (hiddenQty) hiddenQty.value = next;
      });
    });
    if (qtyInput && hiddenQty) {
      qtyInput.addEventListener('change', function () {
        hiddenQty.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        qtyInput.value = hiddenQty.value;
      });
    }

    if (!picker) return;

    var dataEl = qs('[data-variant-json]', picker);
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    function currentSelection() {
      var out = [];
      qsa('.variant-pills', picker).forEach(function (group, i) {
        var sel = qs('.is-selected', group);
        out[i] = sel ? sel.dataset.value : null;
      });
      return out;
    }

    function matchVariant(selection) {
      return variants.find(function (v) {
        return selection.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function markUnavailable(selection) {
      qsa('.variant-pills', picker).forEach(function (group, groupIndex) {
        qsa('.variant-pill', group).forEach(function (pill) {
          var trial = selection.slice();
          trial[groupIndex] = pill.dataset.value;
          var exists = variants.some(function (v) {
            return v.available && trial.every(function (val, i) {
              return i === groupIndex ? v.options[i] === val : (val === null || v.options[i] === val);
            });
          });
          pill.classList.toggle('is-unavailable', !exists);
        });
      });
    }

    function money(cents) {
      var format = window.moneyFormat || '${{amount}}';
      var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var noDecimals = Math.round(cents / 100).toLocaleString('en');
      return format
        .replace(/\{\{\s*amount\s*\}\}/, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals);
    }

    function update() {
      var selection = currentSelection();
      markUnavailable(selection);
      var variant = matchVariant(selection);

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addBtnText) { addBtnText.textContent = window.themeStrings.unavailable; }
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
          if (discountEl) {
            discountEl.textContent = '-' + Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) + '%';
            discountEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (discountEl) discountEl.hidden = true;
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addBtnText) {
          addBtnText.textContent = variant.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
        }
      }

      // Swap the gallery to the variant's image when it has one.
      if (variant.featured_media) {
        var thumb = qs('[data-thumb="' + variant.featured_media.position + '"]', root) ||
                    qs('[data-thumb="' + (variant.featured_media.position - 1) + '"]', root);
        if (thumb) thumb.click();
      }
    }

    qsa('[data-option-value]', picker).forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('.variant-pills');
        qsa('.variant-pill', group).forEach(function (p) { p.classList.toggle('is-selected', p === pill); });
        var label = qs('[data-selected-option="' + pill.dataset.optionIndex + '"]', picker);
        if (label) label.textContent = pill.dataset.value;
        update();
      });
    });

    update();
  });

  /* ---------------- Product recommendations (lazy fetch) ---------------- */

  qsa('[data-product-recommendations]').forEach(function (el) {
    var url = el.dataset.url;
    if (!url) return;
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-product-recommendations]');
          if (fresh) {
            el.innerHTML = fresh.innerHTML;
            document.dispatchEvent(new CustomEvent('theme:rerender', { detail: { target: el } }));
          }
        })
        .catch(function () { /* recommendations are optional */ });
    }, { rootMargin: '400px' });
    observer.observe(el);
  });

  /* ---------------- Predictive search ---------------- */

  qsa('[data-predictive-search]').forEach(function (root) {
    var input = qs('[data-predictive-input]', root);
    var results = qs('[data-predictive-results]', root);
    if (!input || !results) return;

    var timer;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }

      timer = setTimeout(function () {
        var url = window.routes.predictive_search_url +
          '?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search';

        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var inner = parsed.querySelector('#PredictiveSearchResults');
            results.innerHTML = inner ? inner.innerHTML : '';
            results.hidden = !inner;
          })
          .catch(function () { results.hidden = true; });
      }, 250);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) results.hidden = true;
    });
  });

  /* ---------------- Escape closes overlays ---------------- */

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMobileNav();
    qsa('[data-facet-panel], [data-locale-panel], [data-predictive-results]').forEach(function (p) { p.hidden = true; });
    var drawer = qs('[data-cart-drawer]');
    if (drawer && drawer.classList.contains('is-open') && window.closeCartDrawer) window.closeCartDrawer();
  });
})();
